import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {useFavorites} from "components/hooks/useFavorites.js";

const FavoriteButton = ({contentHash, type, hideIfUnfavorited=false}) => { 
    const {toggleFavorite, isFavorited} = useFavorites({
        contentHash: contentHash,
        type
    });

    if (hideIfUnfavorited && !isFavorited) {
        return [];
    }

    return (
        <div
          onClick={toggleFavorite}
          className={isFavorited ? "heart favorited" : "heart"}/>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoriteButton);
